var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHotelR = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 64,
  height: 64,
  viewBox: "0 0 64 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  opacity: 0.8
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 8L16 12L20 16L24 12L20 8ZM24 12L28 16L32 12L28 8L24 12ZM32 12L36 16L40 12L36 8L32 12ZM40 12L44 16L48 12L44 8L40 12ZM44 16H10V56H54V16H44ZM14 20H50V52H38V42H26V52H14V20ZM18 24V28H22V24H18ZM26 24V28H30V24H26ZM34 24V28H38V24H34ZM42 24V28H46V24H42ZM18 30V34H22V30H18ZM26 30V34H30V30H26ZM34 30V34H38V30H34ZM42 30V34H46V30H42ZM18 36V40H22V36H18ZM26 36V40H30V36H26ZM34 36V40H38V36H34ZM42 36V40H46V36H42ZM18 42V46H22V42H18ZM42 42V46H46V42H42ZM30 46H34V52H30V46Z",
  fill: "black",
  fillOpacity: 0.2
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHotelR);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hotel-r.7ef7ecd0abf00b86a884ce260308d140.svg";